import {ZIDX, ZIDXPage} from "../../standalone/standaloneLibrary.js";
import {MarkdownStreamParser} from "../../ai/MarkdownStreamParser.js";

interface ConversationMessage {
    role: string;
    content: string;
    toolName: string;
    toolInput: string;
    inputTokens: number;
    outputTokens: number;
    estimatedCost: string;
    createdAt: string;
}

export class ZIDXAccountAIConversationView implements ZIDXPage {
    zidx: ZIDX;

    constructor(zidx: ZIDX) {
        this.zidx = zidx;
    }

    getPageClass() {
        return "zidxAccountAIConversationViewContainer";
    }

    render() {
        let chatContainer = this.zidx.peakidxShadowRoot.getElementById("aiConvViewChat") as HTMLElement | null;
        if (!chatContainer) return;
        let sessionId = chatContainer.getAttribute("data-session-id");
        if (!sessionId) return;

        chatContainer.style.maxWidth = "800px";
        chatContainer.style.display = "flex";
        chatContainer.style.flexDirection = "column";
        chatContainer.style.gap = "12px";
        chatContainer.textContent = "Loading messages...";

        this.loadMessages(chatContainer, sessionId);
    }

    async loadMessages(chatContainer: HTMLElement, sessionId: string) {
        try {
            let res = await fetch("/account/ai-conversations/view/messages?session_id=" + encodeURIComponent(sessionId), {
                method: "GET",
                credentials: "include",
            });
            let json = await res.json();
            if (!json.success) {
                chatContainer.textContent = json.errorMessage || "Failed to load messages.";
                return;
            }
            let messages: ConversationMessage[] = JSON.parse(json.data);
            chatContainer.textContent = "";
            if (messages.length === 0) {
                chatContainer.textContent = "No messages in this session.";
                return;
            }
            for (let msg of messages) {
                this.renderMessage(chatContainer, msg);
            }
        } catch (e) {
            chatContainer.textContent = "Error loading messages.";
        }
    }

    renderMessage(chatContainer: HTMLElement, msg: ConversationMessage) {
        let bubble = document.createElement("div");
        let role = msg.role || "unknown";
        let content = msg.content || "";

        // Bubble style based on role
        switch (role) {
            case "user":
                bubble.style.cssText = "align-self:flex-end; border-radius:12px 12px 0 12px; padding:10px 14px; max-width:75%; word-break:break-word;";
                break;
            case "assistant":
                bubble.style.cssText = "align-self:flex-start; border-radius:12px 12px 12px 0; padding:10px 14px; max-width:75%; word-break:break-word;";
                break;
            case "summary":
                bubble.style.cssText = "align-self:center; border-radius:8px; padding:8px 12px; max-width:85%; font-size:0.85em; font-style:italic; word-break:break-word;";
                break;
            default:
                bubble.style.cssText = "align-self:center; border-radius:8px; padding:8px 12px; max-width:85%; font-size:0.85em; word-break:break-word;";
                break;
        }

        // Role label
        let roleLabel = document.createElement("div");
        roleLabel.style.cssText = "font-size:0.75em; color:#6b7280; margin-bottom:2px;";
        roleLabel.textContent = role.charAt(0).toUpperCase() + role.slice(1);
        bubble.appendChild(roleLabel);

        // Tool call info
        if (msg.toolName) {
            let toolLabel = document.createElement("div");
            toolLabel.style.cssText = "font-size:0.75em; color:#6b7280;";
            toolLabel.textContent = "Tool: " + msg.toolName;
            bubble.appendChild(toolLabel);
            if (msg.toolInput) {
                let pre = document.createElement("pre");
                pre.style.cssText = "font-size:0.8em; background:rgba(128,128,128,0.1); padding:6px; border-radius:4px; overflow-x:auto; margin:4px 0;";
                pre.textContent = msg.toolInput.length > 500 ? msg.toolInput.substring(0, 500) + "..." : msg.toolInput;
                bubble.appendChild(pre);
            }
        }

        // Content — use MarkdownStreamParser for assistant, plain text for others
        if (content) {
            if (role === "assistant") {
                let contentDiv = document.createElement("div");
                bubble.appendChild(contentDiv);
                let parser = new MarkdownStreamParser(contentDiv);
                parser.feed(content);
                parser.complete();
            } else {
                let contentDiv = document.createElement("div");
                contentDiv.textContent = content;
                bubble.appendChild(contentDiv);
            }
        }

        // Token info
        // let inputTokens = msg.inputTokens || 0;
        // let outputTokens = msg.outputTokens || 0;
        // if (inputTokens > 0 || outputTokens > 0) {
        //     let tokenDiv = document.createElement("div");
        //     tokenDiv.style.cssText = "font-size:0.7em; color:#9ca3af; margin-top:4px;";
        //     let costStr = msg.estimatedCost && msg.estimatedCost !== "0" ? " | $" + msg.estimatedCost : "";
        //     tokenDiv.textContent = "Tokens: Inu:" + inputTokens + " out:" + outputTokens + costStr;
        //     bubble.appendChild(tokenDiv);
        // }

        chatContainer.appendChild(bubble);
    }
}
